import { createFilterAtoms } from '@/common/filtering/store.ts';
import { resetClientPaginationOnFilterChangeAtom } from '@/features/data/clients/pagination.ts';
import {
  DEFAULT_CLIENT_FILTER,
  type ClientFilterDefinition,
} from '@pac/filter/shared/clients';

export const clientFilterAtoms = createFilterAtoms<ClientFilterDefinition>(
  DEFAULT_CLIENT_FILTER,
  resetClientPaginationOnFilterChangeAtom,
);
